import {
    GET_AGENT_ASSIGNMENT,
    GET_ALL_AGENT_ASSIGNMENTS,
    GET_AGENT_ASSIGNMENT_REQUEST,
    CREATE_AGENT_ASSIGNMENT,
    UPDATE_AGENT_ASSIGNMENT,
    DELETE_AGENT_ASSIGNMENT,
    CLEAR_AGENT_ASSIGNMENT,
    AGENT_ASSIGNMENT_ERROR,
    AGENT_ASSIGNMENT_LOADING
} from '../actions/types';

const initialState = {
    agentAssignments: [],
    agentAssignment: null,
    loading: false,
    error: null
};

export default function agentAssignmentReducer(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case AGENT_ASSIGNMENT_LOADING:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_ALL_AGENT_ASSIGNMENTS:
            return {
                ...state,
                agentAssignments: payload,
                loading: false,
                error: null
            };

        case GET_AGENT_ASSIGNMENT_REQUEST:
            return {
                ...state,
                loading: true,
                error: null
            };

        case GET_AGENT_ASSIGNMENT:
            return {
                ...state,
                agentAssignment: payload,
                loading: false,
                error: null
            };

        case CREATE_AGENT_ASSIGNMENT:
            return {
                ...state,
                agentAssignments: [...state.agentAssignments, payload],
                loading: false,
                error: null
            };

        case UPDATE_AGENT_ASSIGNMENT:
            return {
                ...state,
                agentAssignments: state.agentAssignments.map(assignment =>
                    assignment._id === payload._id ? payload : assignment
                ),
                agentAssignment: payload,
                loading: false,
                error: null
            };

        case DELETE_AGENT_ASSIGNMENT:
            return {
                ...state,
                agentAssignments: state.agentAssignments.filter(assignment => assignment._id !== payload),
                loading: false,
                error: null
            };

        case CLEAR_AGENT_ASSIGNMENT:
            return {
                ...state,
                agentAssignment: null,
                error: null
            };

        case AGENT_ASSIGNMENT_ERROR:
            return {
                ...state,
                error: payload,
                loading: false
            };

        default:
            return state;
    }
}
